module.exports = __webpack_public_path__ + "img/05_1_2_1.0f73e849.png";